import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Blog from "./components/Blog";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";

import SellGold from "./pages/SellGold";
import ReleaseGold from "./pages/ReleaseGold"; // ✅ FIXED
import PopupForm from "./components/PopupForm";

import "./App.css";

function App() {
  return (
    <Router>

      <Navbar />

      <Routes>

        {/* HOME PAGE */}
        <Route
          path="/"
          element={
            <>
              <section id="home"><Home /></section>
              <section id="about"><About /></section>
              <section id="services"><Services /></section>
              <section id="testimonials"><Testimonials /></section>
              <section id="contact"><Contact /></section>
              <section id="blog"><Blog /></section>
            </>
          }
        />

        {/* SELL GOLD */}
        <Route path="/sell-gold" element={<SellGold />} />

        {/* RELEASE GOLD */}
        <Route path="/release-gold" element={<ReleaseGold />} />

      </Routes>
<PopupForm />
      <Footer />
      <FloatingButtons />

    </Router>
  );
}

export default App;